import React from 'react';
import SalesOrderPreview from './SalesOrderPreview';
import { reactLocalStorage } from 'reactjs-localstorage';
import BookingPreviewDesign2 from './BookingPreviewDesign2';

class BookingPreviewWrapper extends React.Component {
  render() {
    const designView = reactLocalStorage.get('booking_design') || '2';
    const { ...rest } = this.props;
    return designView === '1' ? (
      <SalesOrderPreview {...rest} />
    ) : (
      <BookingPreviewDesign2 {...rest} />
    );
  }
}

export default BookingPreviewWrapper;
